import { Check, AlertTriangle } from "lucide-react";
import { formatDateTime, STATUS_STYLES } from "@/lib/api";

export const Timeline = ({ history, showAuthor = false }) => {
  const items = [...(history || [])].sort((a, b) => new Date(a.at) - new Date(b.at));
  const lastIndex = items.length - 1;

  return (
    <ol className="relative space-y-0" data-testid="tracking-timeline">
      {items.map((item, i) => {
        const isCurrent = i === lastIndex;
        const isIssue = item.status === "Problème / Retenu en douane";
        const dot = STATUS_STYLES[item.status]?.dot || "bg-slate-400";
        return (
          <li key={`${item.status}-${item.at}`} className="relative flex gap-4 pb-8 last:pb-0"
              data-testid={`timeline-step-${i}`}>
            {i !== lastIndex && (
              <span className="absolute left-[15px] top-8 h-full w-[2px] bg-gradient-to-b from-[#2563EB] to-blue-100" />
            )}
            <span
              className={`relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${
                isIssue ? "bg-[#DC2626]" : isCurrent ? "bg-[#2563EB]" : dot
              } ${isCurrent ? "ring-4 ring-blue-100" : ""}`}
            >
              {isIssue ? (
                <AlertTriangle className="h-4 w-4 text-white" />
              ) : (
                <Check className="h-4 w-4 text-white" />
              )}
            </span>
            <div className="min-w-0 flex-1 pt-0.5">
              <p className={`text-sm font-bold ${isIssue ? "text-[#DC2626]" : "text-slate-900"}`}>
                {item.status}
                {isCurrent && (
                  <span className="ml-2 rounded-full bg-blue-50 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-[#2563EB]">
                    Actuel
                  </span>
                )}
              </p>
              <p className="font-mono text-xs text-slate-500">
                {formatDateTime(item.at)}
                {showAuthor && item.by ? ` · ${item.by}` : ""}
              </p>
              {item.note && <p className="mt-1 text-sm text-slate-600">{item.note}</p>}
            </div>
          </li>
        );
      })}
    </ol>
  );
};
